import clsx from "clsx";

import styles from "./card.module.css";

interface CardProps {
  className?: string;
  children: React.ReactNode;
  display?: {
    padding?: "standard" | "none";
  };
}

export default function Card({ children, className, display }: CardProps) {
  return (
    <div
      className={clsx(styles.card, className, {
        [styles.none]: display?.padding === "none",
      })}
    >
      {children}
    </div>
  );
}
